<template>
  <Popup v-model="val" :centered="successPopup.notcentered?false:true" :closable="!immortalSuccess">
    <h2 class="popup__title">{{successPopup.title}}</h2>
    <p class="popup__text" v-if="successPopup.text" v-html="successPopup.text"></p>
    <div class="popup__btns" v-if="successPopup.type == 'load'">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('setSuccess', false)">Отмена</Btn>
      <Btn @click.native.prevent="$store.commit('setSuccess', false); $store.dispatch('loadAll')" >Да</Btn>
    </div>
    <Btn v-if="successPopup.type == 'finish'" class="popup__btn" @click.native.prevent.stop="toSite">На сайт</Btn>
    <Btn v-if="successPopup.type == 'info'" class="popup__btn" @click.native.prevent.stop="close" >Ок</Btn>
    <Btn v-if="successPopup.type == 'redirect'" class="popup__btn" @click.native.prevent.stop="toSite" >Перейти</Btn>
  </Popup>
</template>

<script>
import Popup from './Popup.vue'

import { mapState } from 'vuex';
import Btn from './ui/Btn.vue';

export default {
  components: { Popup, Btn },
  props: {
    value: Boolean,
  },
  methods: {
    toSite(){
      let url = 'https://rosbankinsurance.ru/'
      if (this.successPopup.type == 'redirect') {
        url = this.successPopup.redirect_url
        this.$store.dispatch('metrikaAction', this.successPopup.ymaction)
      }
      location.assign(url)
    },
    close(){
      this.$store.commit('setSuccess', false)
    }
  },
  computed: {
    ...mapState(['immortalSuccess', 'successPopup']),
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value);},
    }
  }
}
</script>

<style lang="sass">
.popup__btns
  display: flex
  justify-content: space-between
  width: 300px
  max-width: 100%
  .btn
    width: 130px
    max-width: 45%
</style>